import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'common/deps/moment';

@Component({
  props: {
    lastDateString: {
      type: String,
      required: true,
    },
  },
})
export default class CountDownComponent extends Vue {
  countdown = null;
  expires_in = null;
  lastDate = null;
  interval = null;

  created() {
    this.lastDate = moment(this.lastDateString);
    this.expires_in = this.lastDate.diff(moment(), 'seconds');
    this.countdown = moment.utc(this.expires_in * 1000); // moment.utc(0 seconds) = "1970/01/01 00:00:00"
    this._setInterval();
  }

  _setInterval() {
    this.interval = setInterval(() => {
      if (this.expires_in <= 0) {
        this.$emit('finished');
        clearInterval(this.interval);
      } else {
        this.expires_in -= 1;
        this.countdown = moment.utc(this.expires_in * 1000); // moment.utc(0 seconds) = "1970/01/01 00:00:00"
      }
    }, 1000);
  }

  get countDownDays() {
    return this.countdown.format('DD') - 1;
  }

  get countDownMonths() {
    return this.countdown.format('MM') - 1;
  }

  get countDownYear() {
    return this.countdown.format('YYYY') - 1970;
  }
}
